export default __webpack_public_path__ + "static/media/printer.b31f631f.svg";